export default "__VITE_ASSET__55068823__"